import { render, staticRenderFns } from "./MySecurity.vue?vue&type=template&id=242c35a6&"
import script from "./MySecurity.vue?vue&type=script&lang=js&"
export * from "./MySecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports